/**
 * Every downloadable resource on the Girls Program Materials page. Edit this
 * list to add, remove, reorder or relink resources; the page, the hero's
 * resource count and the hero's handbook button all read from it.
 */

export type ResourceGroup = "curriculum" | "supporting" | "promotional";
export type ResourceType = "PDF" | "SLIDES";

export interface Resource {
    title: string;
    type: ResourceType;
    url: string;
    // Shown under the title; supporting and promotional cards have none.
    description?: string;
    group: ResourceGroup;
    // Shown as the large "Start here" card above its group's grid.
    featured?: boolean;
}

export const resources: Resource[] = [
    {
        title: "Facilitator Handbook",
        type: "PDF",
        url: "https://drive.google.com/file/d/1NxvQezX3ro8PUK4hGBlnqQHi40q8U2yg/view?usp=sharing",
        description:
            "Step-by-step facilitator guide and script for easy implementation.",
        group: "curriculum",
        featured: true,
    },
    {
        title: "Kickoff Session: Redefine Leadership",
        type: "PDF",
        url: "https://drive.google.com/file/d/1DHm8xAzQfWVeNaayW2F34JDM4K2COSfD/view?usp=sharing",
        description:
            "Introduces participants to a more expansive definition of leadership that celebrates the everyday ways they’re already leading.",
        group: "curriculum",
    },
    {
        title: "Part 1: Celebrating Girls’ Leadership Superpowers",
        type: "PDF",
        url: "https://drive.google.com/file/d/1jmp58m6PEbmLXSJt7ed2eRSWBOjCPmFz/view?usp=sharing",
        description:
            "Helps participants see how their values and strengths contribute to their unique leadership style.",
        group: "curriculum",
    },
    {
        title: "Part 2: Challenging Stereotypes & Inspiring Girls to Go for It",
        type: "PDF",
        url: "https://drive.google.com/file/d/1zaO5mUWoqqMZF0bU2T8S_oXQAkJCuDEb/view?usp=sharing",
        description:
            "Encourages participants to examine the impact of pressure to please others and to act the way others expect, and to set bold goals and take positive risks despite those pressures.",
        group: "curriculum",
    },
    {
        title: "Part 3: Overcoming Bias & Barriers",
        type: "PDF",
        url: "https://drive.google.com/file/d/1UjZmdmffY82xx0jknQq62-1QQ0y5c1wd/view?usp=sharing",
        description:
            "Guides participants through an age-appropriate exploration of the unfair treatment they may experience due to their gender or other aspects of their identity, and gives them concrete tools to navigate those experiences.",
        group: "curriculum",
    },
    {
        title: "Program Overview",
        type: "PDF",
        url: "https://drive.google.com/file/d/1890gCfVnKk2TPI56GOFAt3b6ZsraSW4v/view?usp=sharing",
        group: "supporting",
    },
    {
        title: "Facilitating Lean In Girls 101",
        type: "PDF",
        url: "https://drive.google.com/file/d/18D5l17KTkRReobXiGV94SaQEdXup2ZHQ/view?usp=sharing",
        group: "supporting",
    },
    {
        title: "Curriculum Scope & Sequence",
        type: "PDF",
        url: "https://drive.google.com/file/d/1mfTO94cwV8K4k5sCMeI1tnbvoWKR3HH2/view?usp=sharing",
        group: "supporting",
    },
    {
        title: "FAQs",
        type: "PDF",
        url: "https://drive.google.com/file/d/18QlDW02POp7cFBDUlo_qSEMrT7maGlMO/view?usp=sharing",
        group: "supporting",
    },
    {
        title: "Promotional Flyer (Caregivers + Girls)",
        type: "PDF",
        url: "https://drive.google.com/file/d/18CxhddH3sZT4Y3KcPndvPXYNDvkDGwVj/view?usp=sharing",
        group: "promotional",
    },
    {
        title: "Promotional Poster",
        type: "PDF",
        url: "https://drive.google.com/file/d/1HvlqdaVjz-J7LutXrXkyqmFF1xSzXTuC/view?usp=sharing",
        group: "promotional",
    },
    {
        // TODO(confirm): file type not yet confirmed; may not be a PDF.
        title: "Social Media Resources",
        type: "PDF",
        url: "https://drive.google.com/file/d/1maAgRAzQJlaExtGMXgq2p3WnMZpCiU23/view?usp=sharing",
        group: "promotional",
    },
    {
        title: "Promotional Language – Newsletter",
        type: "SLIDES",
        url: "https://docs.google.com/presentation/d/1fg1YKphwMTbrtyN2ou9VtZc4HyydiYE7SRDqUO4rFQA/edit?usp=sharing",
        group: "promotional",
    },
];

export const resourcesIn = (group: ResourceGroup) =>
    resources.filter((r) => r.group === group);
